module.exports = __webpack_public_path__ + "img/5trebol.3ac88edd.png";